import { Instance } from 'mobx-state-tree'
import { LearningModuleAndStatModelBase } from './LearningModuleAndStatModel.base'

/* The TypeScript type of an instance of LearningModuleAndStatModel */
export interface LearningModuleAndStatModelType extends Instance<typeof LearningModuleAndStatModel.Type> {}

/* A graphql query fragment builders for LearningModuleAndStatModel */
export {
  selectFromLearningModuleAndStat,
  learningModuleAndStatModelPrimitives,
  LearningModuleAndStatModelSelector
} from './LearningModuleAndStatModel.base'

/**
 * LearningModuleAndStatModel
 */
export const LearningModuleAndStatModel = LearningModuleAndStatModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
